import { NextMonthButton } from './NextMonthButton.js';
import { PreviousMonthButton } from './PreviousMonthButton.js';
import { YearPickerToggleButton } from './YearPickerToggleButton.js';
import { CloseYearPickerButton } from './CloseYearPickerButton.js';
import { HeaderContainer } from '../../styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Header() {
  return /*#__PURE__*/jsxs(HeaderContainer, {
    children: [/*#__PURE__*/jsx(PreviousMonthButton, {}), /*#__PURE__*/jsx(YearPickerToggleButton, {}), /*#__PURE__*/jsx(NextMonthButton, {}), /*#__PURE__*/jsx(CloseYearPickerButton, {})]
  });
}

export { Header };
